import { render, staticRenderFns } from "./threeDotsMenu.vue?vue&type=template&id=37a062d8"
import script from "./threeDotsMenu.vue?vue&type=script&lang=js"
export * from "./threeDotsMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports